import {Engine} from "platform/engine/Engine";
import {AddAlert, SetNewAlertPayload} from "core/redux/alerts/AlertsReduxActions";
import Platform from "platform/Platform";

export default class AlertsEngine extends Engine {

    private static _instance: AlertsEngine;

    public static instance(): AlertsEngine {
        return this._instance || (this._instance = new this());
    }

    public doSetNewAlert = async (payload: SetNewAlertPayload) => {
        const {symbolId, alert} = payload;
        // TODO Emulate request on server and put new Alert instance in reducer array
        Platform.dispatch(AddAlert({symbolId, alert}));
    }
}
